export const routes = [{
    path: '/eixosGrupo',
    component: () =>
        import('./components/List'),
    name: 'eixosGrupo.list',
    meta: {
        requiresAuth: true
    }
}]